class Footer {
  constructor(container) {
    this.container = container
    this.dialogTogglers = container.querySelectorAll('[data-dialog-toggle]')

    this.dialogTogglers.forEach(dialogToggler => {
      dialogToggler.addEventListener('click', e => {
        e.preventDefault()
        this.toggleDialog(dialogToggler.getAttribute('data-dialog-toggle'))
      })
    })
  }

  toggleDialog = dialogId => {
    const dialog = window.dialogs.find(el => el.container.id === dialogId)
    if (dialog) {
      dialog.show()
    }
  }
}

const footer = () => {
  const container = document.querySelector('[data-footer]')
  if (container) {
    new Footer(container)
  }
}

export default footer
